import { render, staticRenderFns } from "./newOaWorkflowFinish.vue?vue&type=template&id=5b7fcc9e&scoped=true"
import script from "./newOaWorkflowFinish.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowFinish.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowFinish.vue?vue&type=style&index=0&id=5b7fcc9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7fcc9e",
  null
  
)

export default component.exports